/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type AdvancedCaseloadParticipantFragment = {
  __typename?: 'Patient'
  uid: string
  firstname?: string | null
  lastname?: string | null
  preferredName?: string | null
  indicators?: {
    __typename?: 'PatientIndicators'
    lastViewedAt?: Date | null
    suicidal?: boolean | null
    overdueHealthQuestionnaire?: boolean | null
    latestReturnedLabOrderID?: string | null
    daysDisengaged?: { __typename?: 'DaysDisengagedIndicator'; days: number; level: Types.AppActivityLevel } | null
    newMessages?: { __typename?: 'PatientNewMessageIndicator'; count: number } | null
    advancedRoleChatNewMessages?: { __typename?: 'PatientNewMessageIndicator'; count: number } | null
    risk?: { __typename?: 'RiskIndicator'; level: Types.RiskLevel; trend: Types.AssessmentTrend } | null
    monthlySummaryNotes?: {
      __typename?: 'MonthlySummaryNoteIndicator'
      count: number
      showIndicator: boolean
      showToast: boolean
    } | null
    currentOrUpcomingCall?: {
      __typename?: 'VideoCall'
      id: string
      callType: Types.VideoCallType
      startTime: Date
      endTime: Date
    } | null
    completedCallAwaitingNote?: {
      __typename?: 'VideoCall'
      id: string
      callType: Types.VideoCallType
      startTime: Date
    } | null
  } | null
  tags?: Array<{ __typename?: 'PatientTag'; id: string; name: string; createdAt: Date }> | null
  careTeam?: Array<{ __typename?: 'CareTeamMember'; coachID: string; isPrimary: boolean }> | null
}

export type GetAdvancedCaseloadParticipantsQueryVariables = Types.Exact<{
  uids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
}>

export type GetAdvancedCaseloadParticipantsQuery = {
  __typename?: 'Query'
  patients: Array<{
    __typename?: 'Patient'
    uid: string
    firstname?: string | null
    lastname?: string | null
    preferredName?: string | null
    indicators?: {
      __typename?: 'PatientIndicators'
      lastViewedAt?: Date | null
      suicidal?: boolean | null
      overdueHealthQuestionnaire?: boolean | null
      latestReturnedLabOrderID?: string | null
      daysDisengaged?: { __typename?: 'DaysDisengagedIndicator'; days: number; level: Types.AppActivityLevel } | null
      newMessages?: { __typename?: 'PatientNewMessageIndicator'; count: number } | null
      advancedRoleChatNewMessages?: { __typename?: 'PatientNewMessageIndicator'; count: number } | null
      risk?: { __typename?: 'RiskIndicator'; level: Types.RiskLevel; trend: Types.AssessmentTrend } | null
      monthlySummaryNotes?: {
        __typename?: 'MonthlySummaryNoteIndicator'
        count: number
        showIndicator: boolean
        showToast: boolean
      } | null
      currentOrUpcomingCall?: {
        __typename?: 'VideoCall'
        id: string
        callType: Types.VideoCallType
        startTime: Date
        endTime: Date
      } | null
      completedCallAwaitingNote?: {
        __typename?: 'VideoCall'
        id: string
        callType: Types.VideoCallType
        startTime: Date
      } | null
    } | null
    tags?: Array<{ __typename?: 'PatientTag'; id: string; name: string; createdAt: Date }> | null
    careTeam?: Array<{ __typename?: 'CareTeamMember'; coachID: string; isPrimary: boolean }> | null
  }>
}

export const AdvancedCaseloadParticipantFragmentDoc = gql`
  fragment AdvancedCaseloadParticipant on Patient {
    uid
    firstname
    lastname
    preferredName
    indicators {
      lastViewedAt
      suicidal
      overdueHealthQuestionnaire
      daysDisengaged {
        days
        level
      }
      newMessages {
        count
      }
      advancedRoleChatNewMessages {
        count
      }
      risk {
        level
        trend
      }
      monthlySummaryNotes {
        count
        showIndicator
        showToast
      }
      currentOrUpcomingCall {
        id
        callType
        startTime
        endTime
      }
      completedCallAwaitingNote {
        id
        callType
        startTime
      }
      latestReturnedLabOrderID
    }
    tags {
      id
      name
      createdAt
    }
    careTeam {
      coachID
      isPrimary
    }
  }
`
export const GetAdvancedCaseloadParticipantsDocument = gql`
  query getAdvancedCaseloadParticipants($uids: [ID!]!) {
    patients(uids: $uids) {
      ...AdvancedCaseloadParticipant
    }
  }
  ${AdvancedCaseloadParticipantFragmentDoc}
`

/**
 * __useGetAdvancedCaseloadParticipantsQuery__
 *
 * To run a query within a React component, call `useGetAdvancedCaseloadParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedCaseloadParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedCaseloadParticipantsQuery({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useGetAdvancedCaseloadParticipantsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdvancedCaseloadParticipantsQuery,
    GetAdvancedCaseloadParticipantsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedCaseloadParticipantsQuery, GetAdvancedCaseloadParticipantsQueryVariables>(
    GetAdvancedCaseloadParticipantsDocument,
    options
  )
}
export function useGetAdvancedCaseloadParticipantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdvancedCaseloadParticipantsQuery,
    GetAdvancedCaseloadParticipantsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedCaseloadParticipantsQuery, GetAdvancedCaseloadParticipantsQueryVariables>(
    GetAdvancedCaseloadParticipantsDocument,
    options
  )
}
export type GetAdvancedCaseloadParticipantsQueryHookResult = ReturnType<typeof useGetAdvancedCaseloadParticipantsQuery>
export type GetAdvancedCaseloadParticipantsLazyQueryHookResult = ReturnType<
  typeof useGetAdvancedCaseloadParticipantsLazyQuery
>
export type GetAdvancedCaseloadParticipantsQueryResult = Apollo.QueryResult<
  GetAdvancedCaseloadParticipantsQuery,
  GetAdvancedCaseloadParticipantsQueryVariables
>
